import ReviewHeaderContainer from 'redux/containers/components/review/ReviewHeaderContainer'

export default ReviewHeaderContainer
